<template>
    <div class="content">
        <div class="content-view" ref="scrollbar">
            <div class="action" v-if="next == 1">
                <div class="action-title">选择客户</div>
                <el-descriptions title="" :column="1" size="medium" labelClassName="custom-label">
                    <el-descriptions-item label="订单类型">
                        <el-input placeholder="请输入订单类型" value="销售订单" clearable class="el-select-big" readonly></el-input>
                    </el-descriptions-item>
                    <el-descriptions-item label="客户类型">
                        <el-radio-group v-model="Customer_Type" @input="onChange">
                            <el-radio label="0">企业客户</el-radio>
                            <el-radio label="1">个人客户</el-radio>
                        </el-radio-group>
                    </el-descriptions-item>

                    <el-descriptions-item label="姓名" v-if="Customer_Type == 1">
                        <el-input v-model="Person_Name" placeholder="" clearable class="el-select-max"></el-input>
                    </el-descriptions-item>
                    <el-descriptions-item label="手机" v-if="Customer_Type == 1">
                        <el-input v-model="Person_Mobile" placeholder="" clearable class="el-select-max"></el-input>
                    </el-descriptions-item>
                    <el-descriptions-item label="客户名称" v-if="Customer_Type == 0">
                        <el-input v-model="Customer_Name" placeholder="请输入客户名称" clearable class="el-select-max"></el-input>
                        <el-button type="primary" style="margin-left: 10px" @click="getCheckCustomerAndCustomerSub()">查询</el-button>
                    </el-descriptions-item>

                    <el-descriptions-item label="客户编号" v-if="Customer_Type == 0 && Customer_info.Customer_Code">
                        <span>{{ Customer_info.Customer_Code }}</span>
                    </el-descriptions-item>
                    <el-descriptions-item label="客户名称" v-if="Customer_Type == 0 && Customer_info.Customer_Code">
                        <span>{{ Customer_info.Customer_Name }}</span>
                        <span v-if="Customer_info.Customer_IsESign == 1" class="signature-tips">已注册电子签章</span>
                    </el-descriptions-item>
                    <el-descriptions-item label="客户类型" v-if="Customer_Type == 0 && Customer_info.Customer_Code">
                        <span>{{ Customer_Type == 0 ? '企业客户' : '个人客户' }}</span>
                    </el-descriptions-item>
                    <el-descriptions-item label="注册所在地" v-if="Customer_Type == 0 && Customer_info.Customer_Code">
                        <span>{{ Customer_info.Customer_RegAddr }}</span>
                    </el-descriptions-item>
                    <el-descriptions-item label="客户信息" v-if="Customer_Type == 0 && Customer_info.Customer_Code">
                        <div class="customers-info">
                            <el-table :data="OfficeCustomer" style="width: 1200px" border :header-cell-style="{ backgroundColor: '#F5F7FA' }">
                                <el-table-column prop="Amount" label="欠款金额" align="center"></el-table-column>
                                <el-table-column prop="in0" label="未到期金额" align="center"></el-table-column>
                                <el-table-column prop="in2" label="<4个月(元)" align="center"></el-table-column>
                                <el-table-column prop="2to3" label="4-6个月(含)(元)" align="center"></el-table-column>
                                <el-table-column prop="3to5" label="6-12个月(元)" align="center"></el-table-column>
                                <el-table-column prop="up5" label=">12个月(元)" align="center"></el-table-column>
                                <el-table-column prop="score" label="信控评分" align="center"></el-table-column>
                                <el-table-column prop="actionAmount" label="未结诉讼的总金额" align="center"></el-table-column>
                                <el-table-column prop="action" label="诉讼数量" align="center"></el-table-column>
                            </el-table>
                            <el-table :data="CreditCustomer" style="width: 1200px; margin-top: 30px" border :header-cell-style="{ backgroundColor: '#F5F7FA' }">
                                <el-table-column prop="RegistStute" label="注册状态" align="center"></el-table-column>
                                <el-table-column prop="ExecutedpersonCount" label="被执行人次数" align="center"></el-table-column>
                                <el-table-column prop="ExecutedpersonAmount" label="被执行人金额" align="center"></el-table-column>
                                <el-table-column prop="ExecutionListCount" label="失信被执行人次数" align="center"></el-table-column>
                                <el-table-column prop="ExecutionListAmount" label="失信被执行人金额" align="center"></el-table-column>
                                <el-table-column prop="RestrictedConsumerCount" label="限制高消费次数" align="center"></el-table-column>
                            </el-table>
                            <div class="er_Custome">
                                <div style="display: flex; align-items: center; margin-top: 20px">
                                    <h4>授权签约客户：</h4>
                                    <el-input v-model="CustomerSub_Name" placeholder="请输入客户名称" clearable class="el-select-max"></el-input>
                                    <el-button type="primary" style="margin-left: 10px" :disabled="this.Customer_info.CustomerSubs != 'True'" @click="chooseCustomerInfor()">查询</el-button>
                                </div>
                                <div v-if="sub_customerInfor.Customer_ID">
                                    <el-radio v-model="radioSub_customerInfor" text-color="#fff" label="1" style="display: flex; align-items: center; line-height: 50px">
                                        <div style="display: flex; line-height: 50px">
                                            <div style="display: flex; margin-right: 10px">
                                                <h4>客户名称：{{ sub_customerInfor.CustomerSub_Name }}</h4>
                                            </div>
                                            <div style="display: flex">
                                                <h4>客户电话：</h4>
                                                {{ sub_customerInfor.CustomerSub_Mobile }}
                                            </div>
                                        </div>
                                    </el-radio>
                                </div>
                            </div>
                        </div>
                    </el-descriptions-item>
                    <el-descriptions-item label="历史客户" v-if="Customer_Type == 0">
                        <el-radio-group v-model="Customer_ID" @input="historyChange">
                            <div class="his-customers" v-for="(item, index) in Orders_Customer" :key="index">
                                <el-radio :label="item.Orders_CustomerID">{{ item.Customer_Name }}</el-radio>
                            </div>
                        </el-radio-group>
                    </el-descriptions-item>
                </el-descriptions>
            </div>

            <div class="action" v-if="next == 2">
                <div class="action-title">选择付款方式</div>
                <el-descriptions title="" labelClassName="custom-label">
                    <el-descriptions-item label="订单类型">{{ Orders_Type == 0 ? '销售订单' : Orders_Type == 1 ? '服务订单' : '' }}</el-descriptions-item>
                    <el-descriptions-item label="客户名称">{{ Customer_info.Customer_Name }}</el-descriptions-item>
                    <el-descriptions-item label="客户编号" v-if="Customer_Type == 0">{{ Customer_info.Customer_Code }}</el-descriptions-item>
                    <el-descriptions-item label="客户手机" v-else>{{ Customer_info.Person_Mobile }}</el-descriptions-item>
                    <el-descriptions-item label="客户类型">{{ Customer_Type == 0 ? '企业客户' : '个人客户' }}</el-descriptions-item>
                    <el-descriptions-item label="注册所在地" v-if="Customer_Type == 0">{{ Customer_info.Customer_RegAddr }}</el-descriptions-item>
                </el-descriptions>
                <el-descriptions title="" :column="1" labelClassName="custom-label">
                    <el-descriptions-item label="付款方式">
                        <Payment ref="Payment" :istemporary="1" :customerInfor="customerInfor" :changePayInfoData="changePayInfoData" :SPCApply_PayTypeID="SPCApply_PayTypeID" :SPCApply_PayTypeName="SPCApply_PayTypeName" />
                    </el-descriptions-item>
                </el-descriptions>
            </div>

            <div class="action" v-if="next == 3">
                <div class="action-title">选择商品</div>
                <el-descriptions title="">
                    <el-descriptions-item label="订单类型">{{ Orders_Type == 0 ? '销售订单' : Customer_info.Orders_Type == 1 ? '服务订单' : '' }}</el-descriptions-item>
                    <el-descriptions-item label="客户名称">{{ Customer_info.Customer_Name }}</el-descriptions-item>
                    <el-descriptions-item label="客户编号" v-if="Customer_Type == 0">{{ Customer_info.Customer_Code }}</el-descriptions-item>
                    <el-descriptions-item label="客户手机" v-else>{{ Customer_info.Person_Mobile }}</el-descriptions-item>
                    <el-descriptions-item label="客户类型">{{ Customer_Type == 0 ? '企业客户' : '个人客户' }}</el-descriptions-item>
                    <el-descriptions-item label="注册所在地">{{ Customer_info.Customer_RegAddr }}</el-descriptions-item>
                    <el-descriptions-item label="付款方式">{{ submitpaymentObj.value }}</el-descriptions-item>
                </el-descriptions>
                <div class="tabs-container">
                    <div class="sticky-tabs">
                        <el-tabs v-model="activeName" @tab-click="handleClick">
                            <el-tab-pane label="常用商品" name="1"></el-tab-pane>
                            <el-tab-pane label="普通销售件" name="2"></el-tab-pane>
                            <el-tab-pane label="控制柜配置" name="3"></el-tab-pane>
                            <el-tab-pane label="壁挂式控制器" name="4"></el-tab-pane>
                            <el-tab-pane label="促销活动" name="5"></el-tab-pane>
                        </el-tabs>
                        <div v-show="activeName === '2'" class="sticky-form">
                            <el-form :inline="true" class="demo-form-inline">
                                <el-form-item label="选择类别">
                                    <el-select v-model="serch_productList.product_cate" placeholder="" class="el-select-medium">
                                        <el-option v-for="item in Product_cate_parentList" :key="item.Cate_ID" :label="item.Cate_Name" :value="item.Cate_ID"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="折扣分组">
                                    <el-select v-model="serch_productList.DiscounntCate" placeholder="" class="el-select-medium">
                                        <el-option v-for="item in Product_cate_DiscountList" :key="item.ID" :label="item.Name" :value="item.ID"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="选择销售组">
                                    <el-select v-model="serch_productList.SaleGroup_ID" placeholder="" class="el-select-medium">
                                        <el-option v-for="item in Product_cate_SaleGroupIDList" :key="item.SaleGroup_ID" :label="item.SaleGroup_Name" :value="item.SaleGroup_ID"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="商品名称">
                                    <el-input v-model="serch_productList.keyword" class="el-select-medium" placeholder="请输入商品名称进行搜索"></el-input>
                                </el-form-item>
                                <el-form-item>
                                    <el-button type="primary" @click="cartProductList(true)" icon="el-icon-search" :loading="loadingBtn">搜索</el-button>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                    <div class="scroll-content">
                        <div v-show="activeName === '1'">
                            <!-- <div class="content-table-title" style="margin-bottom: 20px">
                                <span></span>
                                <span></span>
                            </div> -->

                            <el-table :data="productCommonList" ref="productCommonTable" style="width: 100%" border :header-cell-style="{ backgroundColor: '#F5F7FA' }" @selection-change="handleSelectionChange">
                                <el-table-column type="selection" width="55" align="center"></el-table-column>
                                <el-table-column prop="Product_Intro" label="销售组" align="center" width="120" show-overflow-tooltip></el-table-column>
                                <el-table-column prop="Product_Code" label="商品编码" align="center" width="80"></el-table-column>
                                <el-table-column prop="Product_Name" label="商品名称" width="350">
                                    <template v-slot="scope">
                                        <div style="display: flex; align-items: center;">
                                            <img :src="getFullImageUrl(scope.row.Product_Img)" @click="showImageDetail(scope.row)" alt="" style="width: 40px; height: auto; object-fit: contain; margin-right: 5px">
                                            <span>{{ scope.row.Product_Name }}</span>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="Product_Spec" label="规格" show-overflow-tooltip align="center" width="150"></el-table-column>
                                <el-table-column prop="Product_SupplyCycle" label="库存" align="center" width="130">
                                    <template slot="header">
                                        <span class="flex-content-center">
                                            库存
                                            <el-popover placement="top-start" title="" trigger="hover" content="库存数量非实时库存，每两小时更新一次">
                                                <span slot="reference" class="flex-content-center"><img src="@/assets/images/wenh.png" alt="" style="width: 15px; height: 15px; margin-left: 2px" /></span>
                                            </el-popover>
                                        </span>
                                    </template>
                                    <template slot-scope="scope">
                                        <div v-html="scope.row.Product_SupplyCycle"></div>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="Product_Price" label="单价" align="center" width="100">
                                    <template v-slot="scope">
                                        <div>￥{{ scope.row.Product_Price.toFixed(2) }}</div>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="prop" label="数量" align="center" width="80">
                                    <template v-slot="scope">
                                        <el-input v-model="scope.row.userDefinedNum" :min="0" :max="9999999"></el-input>
                                    </template>
                                </el-table-column>
                                
                                <el-table-column prop="prop" label="操作" align="center" width="120">
                                    <template v-slot="">
                                        <div class="operation-bar">
                                            <span class="operation-bar-block operation-bar-block-del" @click="addeQuipment('del', scope.row)">移除常用设备</span>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="prop" label="合计" align="center" width="150">
                                    <template v-slot="scope">
                                        <div>￥{{ (scope.row.Product_Price * scope.row.userDefinedNum).toFixed(2) }}</div>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                        <div v-show="activeName === '2'">
                            <div class="content-head">
                                <div class="content-table-title" style="margin-bottom: 20px">
                                    <span></span>
                                    <span></span>
                                </div>
                            </div>

                            <div class="table-container" @scroll="handleScroll" ref="tableContainer">
                                <el-table :data="productList" style="width: 100%" border :header-cell-style="{ backgroundColor: '#F5F7FA' }" @selection-change="handleSelectionChange" ref="productListTable" :row-class-name="getRowClassName">
                                    <el-table-column type="selection" width="55" align="center"></el-table-column>
                                    <el-table-column prop="Product_Intro" label="销售组" align="center" show-overflow-tooltip width="120"></el-table-column>
                                    <el-table-column prop="Product_Code" label="商品编码" align="center" width="80"></el-table-column>
                                    <el-table-column prop="Product_SubName" label="商品名称" width="350">
                                         <template v-slot="scope">
                                            <div style="display: flex; align-items: center;">
                                                <img :src="getFullImageUrl(scope.row.Product_Img)" @click="showImageDetail(scope.row)" alt="" style="width: 40px; height: auto; object-fit: contain; margin-right: 5px">
                                                <span>{{ scope.row.Product_SubName }}</span>
                                            </div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="Product_Spec" label="规格" show-overflow-tooltip align="center" width="150"></el-table-column>
                                    <el-table-column prop="Product_SupplyCycle" label="库存" align="center" width="130">
                                        <template slot="header">
                                            <span class="flex-content-center">
                                                库存
                                                <el-popover placement="top-start" title="" trigger="hover" content="库存数量非实时库存，每两小时更新一次">
                                                    <span slot="reference" class="flex-content-center"><img src="@/assets/images/wenh.png" alt="" style="width: 15px; height: 15px; margin-left: 2px" /></span>
                                                </el-popover>
                                            </span>
                                        </template>
                                        <template slot-scope="scope">
                                            <div v-html="scope.row.Product_SupplyCycle"></div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="Product_Price" label="单价" align="center" width="100">
                                        <template v-slot="scope">
                                            <div>￥{{ scope.row.Product_Price.toFixed(2) }}</div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="prop" label="数量" align="center" width="80">
                                        <template v-slot="scope">
                                            <el-input v-model="scope.row.userDefinedNum" :min="0" :max="9999999"></el-input>
                                        </template>
                                    </el-table-column>
                                    
                                    <el-table-column prop="prop" label="操作" align="center" width="120">
                                        <template v-slot="scope">
                                            <div class="operation-bar" v-if="scope.row.Product_Sort == 0">
                                                <span class="operation-bar-block operation-bar-block-del" @click="addeQuipment('Add', scope.row)">设置为常用设备</span>
                                            </div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="prop" label="合计" align="center" width="150">
                                        <template v-slot="scope">
                                            <div>￥{{ (scope.row.Product_Price * scope.row.userDefinedNum).toFixed(2) }}</div>
                                        </template>
                                    </el-table-column>
                                </el-table>
                                <!-- 加载状态提示 -->
                                <div v-if="loadingMore" class="loading-more">
                                    <i class="el-icon-loading rotating"></i>
                                    <span>加载中...</span>
                                </div>
                                <!-- 没有更多数据提示 -->
                                <div v-if="noMoreData && productList.length > 0" class="no-more-data">没有更多数据了</div>
                            </div>
                        </div>
                        <div v-show="activeName === '3'">
                            <ControlCabinet :Orders_Type="Orders_Type" :Orders_SourceCate="Orders_SourceCate" :shoppingCarts="shoppingCarts" @Cart_ControlCabinetPackage_Add="Cart_ControlCabinetPackage_Add" @searchShoppingCart="searchShoppingCart" ref="ControlCabinet"></ControlCabinet>
                        </div>
                        <div v-show="activeName === '4'">
                            <GetWallHanging :Orders_Type="Orders_Type" :Customerid="customerInfor.Customer_ID" :Orders_SourceCate="Orders_SourceCate" :shoppingCarts="shoppingCarts" @Cart_WallHanging_Add="Cart_WallHanging_Add" @searchShoppingCart="searchShoppingCart" ref="GetWallHanging"></GetWallHanging>
                        </div>
                        <div v-show="activeName === '5'">
                            <div class="content-head">
                                <el-form :inline="true" class="demo-form-inline">
                                    <el-form-item label="选择活动">
                                        <el-select v-model="activityParams.default_activity" placeholder="" class="el-select-medium">
                                            <el-option v-for="item in activityAmountList" :key="item.Promotion_Activity_ID" :label="item.Promotion_Activity_Title" :value="item.Promotion_Activity_ID"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="选择销售组">
                                        <el-select v-model="activityParams.SaleGroup_ID" placeholder="" class="el-select-medium">
                                            <el-option v-for="item in activity_cate_SaleGroupIDList" :key="item.SaleGroup_ID" :label="item.SaleGroup_Name" :value="item.SaleGroup_ID"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="商品名称">
                                        <el-input v-model="activityParams.keyword" class="el-select-medium" placeholder="请输入商品名称进行搜索"></el-input>
                                    </el-form-item>
                                    <el-form-item>
                                        <el-button type="primary" @click="cartActivityProductList(true)" icon="el-icon-search" :loading="loadingBtn">搜索</el-button>
                                    </el-form-item>
                                </el-form>
                                <div class="content-table-title" style="margin-bottom: 20px">
                                    <span></span>
                                    <span></span>
                                </div>
                            </div>
                            <el-table :data="activityProductList" ref="activityProductListTable" style="width: 100%" border :header-cell-style="{ backgroundColor: '#F5F7FA' }" @selection-change="handleSelectionChange">
                                <el-table-column type="selection" width="55" align="center"></el-table-column>
                                <el-table-column prop="Product_Contract" label="促销活动" align="center" width="160"></el-table-column>
                                <el-table-column prop="Product_Intro" label="销售组" show-overflow-tooltip align="center" width="120"></el-table-column>
                                <el-table-column prop="Product_Code" label="商品编码" align="center" width="80"></el-table-column>
                                <el-table-column prop="Product_SubName" label="商品名称" align="left" width="350">
                                    <template v-slot="scope">
                                        <div style="display: flex; align-items: center;">
                                            <img :src="getFullImageUrl(scope.row.Product_Img)" @click="showImageDetail(scope.row)" alt="" style="width: 40px; height: auto; object-fit: contain; margin-right: 5px">
                                            <span>{{ scope.row.Product_SubName }}</span>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="Product_Spec" label="规格" align="center" show-overflow-tooltip width="150"></el-table-column>
                                <el-table-column prop="Product_SupplyCycle" label="库存" align="center" width="130">
                                    <template slot="header">
                                        <span class="flex-content-center">
                                            库存
                                            <el-popover placement="top-start" title="" trigger="hover" content="库存数量非实时库存，每两小时更新一次">
                                                <span slot="reference" class="flex-content-center"><img src="@/assets/images/wenh.png" alt="" style="width: 15px; height: 15px; margin-left: 2px" /></span>
                                            </el-popover>
                                        </span>
                                    </template>
                                    <template slot-scope="scope">
                                        <div v-html="scope.row.Product_SupplyCycle"></div>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="Product_Price" label="单价" align="center" width="100">
                                    <template v-slot="scope">
                                        <div>￥{{ scope.row.Product_Price.toFixed(2) }}</div>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="prop" label="数量" align="center" width="80">
                                    <template v-slot="scope">
                                        <el-input v-model="scope.row.userDefinedNum" :min="0" :max="9999999"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="prop" label="合计" align="center" width="100">
                                    <template v-slot="scope">
                                        <div>￥{{ (scope.row.Product_Price * scope.row.userDefinedNum).toFixed(2) }}</div>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                </div>
            </div>

            <div class="action" v-if="next == 4">
                <div class="action-title">我的购物车</div>
                <div class="content-table-title sticky-tabs" style="padding: 20px 0">
                    <span>
                        <el-button type="primary" @click="continueShopping()">继续购买</el-button>
                        <el-button type="primary" @click="deleterChoose()">批量删除</el-button>
                        <el-button type="primary" @click="allDelete()">一键清空</el-button>
                        <el-button type="primary" @click="cartExport()">导出Excel</el-button>
                        <el-button type="primary" @click="productExport()">下载商品清单</el-button>
                        <el-button type="primary" @click="importExcel()">导入excel</el-button>
                    </span>
                    <span>
                        <span style="color: red; margin-right: 20px">请在此页面与顾客仔细核对采购商品信息及数量</span>
                        <el-button type="primary" :loading="cartEditing" :disabled="cartEditing" @click="goSubmit">去结算</el-button>
                    </span>
                </div>
                <ShoppingCart :Twlist="Twlist" :TradeType="TradeType" ref="ShoppingCart" @selectionChange="selectionChange" @delete="listDelete" @change="officeCartGoodstmpEdit" :allCartPrice="allCartPrice"></ShoppingCart>
                <div style="text-align: center; margin-top: 20px"></div>
            </div>

            <div class="action" v-show="next == 5" v-if="next >= 5">
                <div class="action-title">完善报价单信息</div>
                <SubmitSpcOrder @mountedEnd="submitMountedMethods()" @userComputer="computerMethods" :Orders_Type="Orders_Type" :TradeType="TradeType" :Customer_info="Customer_info" :submitpaymentObj="submitpaymentObj" :cartList="cartList" :activityCartList="activityCartList" :SPCApply_BillType="0" :applyId="applyId" ref="SubmitSpcOrder" @delete="listDelete"></SubmitSpcOrder>
            </div>
            <div class="action" v-if="next == 6">
                <div class="action-title">确认报价单信息</div>
                <ConfirmSpcOrder :cartList="confirmCartList" :activityCartList="confirmActivityCartList" :Orders_Type="Orders_Type" :TradeType="TradeType" :submitpaymentObj="submitpaymentObj" :SPCApply_BillType="0" :Customer_info="Customer_info" ref="ConfirmSpcOrder"></ConfirmSpcOrder>
            </div>
            <div v-if="next == 3" class="customerButtom">
                <el-button @click="next--">上一步</el-button>
                <el-button type="primary" v-show="activeName != 3 && activeName != 4" @click="getopenControlAdd()">加入商品到购物车</el-button>
                <el-button type="primary" v-show="activeName == 3" @click="CartControlCabinetPackageAdd()">加入配柜到购物车</el-button>
                <el-button type="primary" v-show="activeName == 4" @click="CartWallHangingAdd()">加入壁挂到购物车</el-button>
                <el-button type="primary" @click="searchShoppingCart()">查看购物车({{ shoppingCarts }})</el-button>
            </div>
            <div class="customerButtom" v-else-if="next != 6 && next != 5">
                <el-button @click="next--" v-if="next != 1 && next < 5">上一步</el-button>
                <el-button type="primary" @click="onNext()" v-if="next < 3 || next == 5">下一步</el-button>
            </div>
            <div v-else-if="next == 5" style="text-align: center; margin-top: 20px">
                <el-button @click="goCarshop">上一步</el-button>
                <el-button type="primary" @click="onNext()" v-if="next < 3 || next == 5">下一步</el-button>
            </div>
            <div v-else style="text-align: center; margin-top: 20px">
                <el-button @click="stepConfirmOrders">上一步</el-button>
                <el-button type="primary" @click="confirmOrdersCreate('保存')">保存</el-button>
            </div>
            <!-- 商机客户列表弹窗 -->
            <el-dialog title="项目列表" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" :visible.sync="dialogVisible" width="80%">
                <el-table height="450" :data="PipelineList" style="width: 100%" border :header-cell-style="{ backgroundColor: '#F5F7FA' }">
                    <el-table-column align="center" width="55">
                        <template #default="{ row, index }">
                            <el-radio :label="row.ID" v-model="PipelineId">{{ index }}</el-radio>
                        </template>
                    </el-table-column>
                    <el-table-column prop="projectName" label="项目信息" align="center"></el-table-column>
                    <el-table-column prop="stageName" label="项目阶段" align="center"></el-table-column>
                    <el-table-column prop="money" label="预计项目金额" align="center"></el-table-column>
                    <el-table-column prop="entityType" label="项目类型" align="center"></el-table-column>
                    <el-table-column prop="demandDate" label="需货时间" align="center"></el-table-column>
                    <el-table-column prop="createdAt" label="创建日期" align="center"></el-table-column>
                    <el-table-column prop="accountName" label="客户名称" align="center"></el-table-column>
                    <el-table-column prop="" label="联系人" align="center"></el-table-column>
                    <el-table-column prop="userName" label="所有人" align="center"></el-table-column>
                    <el-table-column prop="city" label="项目地址" align="center"></el-table-column>
                </el-table>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="cancelDialog('Pipeline')">取 消</el-button>
                    <el-button type="primary" @click="confirmelection('Pipeline')">确 定</el-button>
                </span>
            </el-dialog>
            <!-- 关联报价单弹窗 -->
            <el-dialog title="关联报价单" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" :visible.sync="dialogVisibleSpc" width="80%">
                <el-table :data="spcList" style="width: 100%" border :header-cell-style="{ backgroundColor: '#F5F7FA' }">
                    <el-table-column align="center" width="55">
                        <template #default="{ row, index }">
                            <el-radio :label="row.Apply_ID" v-model="spcId">{{ index }}</el-radio>
                        </template>
                    </el-table-column>
                    <el-table-column prop="Apply_SN" label="报价单编号" align="center"></el-table-column>
                    <el-table-column prop="SPCApply_ProjectName" label="工程名称" align="center"></el-table-column>
                    <el-table-column prop="SPCApply_OfficeManName" label="业务员" align="center"></el-table-column>
                </el-table>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="cancelDialog('spc')">取 消</el-button>
                    <el-button type="primary" @click="confirmelection('spc')">确 定</el-button>
                </span>
            </el-dialog>
        </div>
        <el-dialog title="导入商品" :close-on-click-modal="false" :visible.sync="importExcelShow" width="60%">
            <div class="labelClassNameBox">
                <el-descriptions title="" :column="1" labelClassName="labelClassName" border>
                    <el-descriptions-item label="上传文件">
                        <Hwupload ref="Hwupload" @onSuccess="onSuccessExcel"></Hwupload>
                    </el-descriptions-item>
                    <el-descriptions-item label="导入文件路径">
                        <el-input v-model="carExexlFilepath" placeholder="请输入" clearable class="el-select-max"></el-input>
                    </el-descriptions-item>
                </el-descriptions>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="importCartGoods()">开始导入</el-button>
            </span>
        </el-dialog>
           <ProductImg 
            :productId="currentProductId" 
            :visible.sync="showProductImgDialog"
            @close="showProductImgDialog = false"
        />
    </div>
     
</template>
<script>
import { cloneDeep } from 'lodash';
import Payment from '@/components/Payment/index.vue';
import ShoppingCart from '@/components/ShoppingCart/index.vue';
import SubmitSpcOrder from './components/submitQuaOrder.vue';
import ConfirmSpcOrder from './components/comfirmQuoOrder.vue';
import ControlCabinet from '@/components/ControlCabinet/index.vue';
import GetWallHanging from '@/components/GetWallHanging/index.vue';
import Hwupload from '@/components/Hwupload/indexlocal.vue';
import Pagination from '@/components/Pagination.vue';
import ProductImg from '@/components/ProductImg'
export default {
    name: 'temporarilyPricesheetadd',
    components: {
        Payment,
        ShoppingCart,
        SubmitSpcOrder,
        ConfirmSpcOrder,
        ControlCabinet,
        GetWallHanging,
        Hwupload,
        Pagination,
        ProductImg
    },
    data() {
        return {
            next: 1,
            applyId: '',
            customerInfor: {},
            sub_customerInfor: {}, // 二级客户
            radioSub_customerInfor: '1', // 二级客户
            Customer_Type: '0',
            Customer_ID: '',
            Customer_Name: '',
            Person_Name: '',
            Person_Mobile: '',
            CustomerSub_Name: '',
            keyword: '',
            loadingBtn: false,
            Customer_info: {
                Customer_Code: '',
                Customer_IsLimitPay: '0'
            },
            serch_productList: {
                keyword: '',
                product_cate: 0,
                DiscounntCate: 0,
                SaleGroup_ID: 0
            },
            OfficeCustomer: [],
            Orders_Customer: [],

            activeName: '1', //商品列表index 1常用商品 2普通销售件 3控制柜配置 4壁挂式控制器 5促销活动
            activeShopList: [], //当前项选中的商品列表
            productCommonList: [], //常用商品列表
            productList: [], //普通商品列表
            Product_cate_parentList: [{ Cate_Name: '全部分类', Cate_ID: 0 }],
            Product_cate_DiscountList: [{ Name: '全部折扣分组', ID: 0 }],
            Product_cate_SaleGroupIDList: [{ SaleGroup_Name: '全部销售组', SaleGroup_ID: 0 }],
            AllCategoryList: [], //全部分类
            // 促销活动
            activityProductList: [],
            activityAmountList: [{ Promotion_Activity_ID: -1, Promotion_Activity_Title: '选择活动' }], //促销活动选择活动
            activity_cate_SaleGroupIDList: [{ SaleGroup_Name: '全部销售组', SaleGroup_ID: 0 }], //促销活动销售组
            activityShopList: [], //促销活动选中的商品列表
            activityProductListOptions: {
                //促销活动商品列表分页器
                PageSize: 400,
                Page: 1,
                total: 0
            },
            activityParams: {
                default_activity: -1,
                SaleGroup_ID: 0,
                keyword: ''
            },

            orders_id: -1,
            TradeType: 1, //0不清楚  1报价单 2报价单(打包订单)
            Orders_SourceCate: 0, //报价单来源    0报价单1报价单变更2独立报价单
            saleType: 0, //报价单类型  0销售报价单 1服务和物联网报价单
            Orders_Type: 0, //订单类型，0：销售订单，1：服务订单
            orders_copy: 0, //复制1

            orderTypeList: [],
            Pipeline_Key: '', //商机客户列表
            dialogVisible: false, //商机客户列表弹窗
            PipelineList: [], //商机客户列表,
            PipelineId: 0, //商机客户列表选中项目id
            dialogVisibleSpc: false, //关联报价单弹窗
            spcList: [], //关联报价单列表
            spcId: 0, //关联报价单选中id

            submitpaymentObj: {}, //提交订单支付方式

            Twlist: [], //购物车列表
            operationShow: false,
            nowCartId: [], //选中的商品id

            isini: true,
            cartgoods: '', //采购清单信息
            cartList: [], //普通商品信息
            activityCartList: [], //促销活动商品信息
            confirmCartList: [], //确认页面普通商品信息
            confirmActivityCartList: [], //确认页面促销活动商品信息
            allMoney: 0, //总金额
            discountObj: {}, //折扣信息

            uploadmentList: [], //需要提交的上传列表

            SPCApply_AdderID: '', //业务员id
            nowOtherAgreement: [], //其他协议

            ispreview: false, //完善报价单页面为false,确认页面为true
            isconfirm: false, //完善报价单页面为false,确认页面为true
            shoppingCarts: 0, // 购物车数量
            importExcelShow: false, //导入excel弹窗
            carExexlFilepath: '', //导入文件路径
            productListOptions: {
                //普通商品列表分页器
                PageSize: 40,
                Page: 1,
                total: 0
            },
            loadingMore: false, // 是否正在加载更多数据
            noMoreData: false, // 是否没有更多数据
            hasMoreData: true, // 是否还有更多数据可加载
            CreditCustomer: [], //信用客户
            changePayInfoData: {}, //付款方式
            SPCApply_PayTypeID: '', //付款方式id
            SPCApply_PayTypeName: '', //付款方式名称
            allCartPrice: 0, //所有商品总价
            cartEditing: false,
            showProductImgDialog: false, // 显示产品图片详情弹窗
            currentProductId: '', // 当前选中的产品id
        };
    },
    created() {
        // 修改报价单
        if (this.$route.query.changeSPCApplyDataID) {
            this.applyId = this.$route.query.changeSPCApplyDataID;
            this.orders_copy = 0;
            this.changeOrder();
        }
        if (this.$route.query.copySPCApplyDataID) {
            this.applyId = this.$route.query.changeSPCApplyDataID;
            this.orders_copy = 1;
            this.copyOrder();
        }
    },
    mounted() {
        this.getCheckSPCOrderCreate();
        this.getHistoryCustomerList();
        this.$store.dispatch('fetchLocationData');
    },
    watch: {
        next(newVal, oldval) {
            if (newVal != oldval) {
                this.$nextTick(() => {
                    try {
                        this.$refs.scrollbar.scrollTop = 0;
                    } catch (e) {
                        console.log(e);
                    }
                });
            }
            if (newVal && newVal === 3) {
                this.cartProductCountAmount();
            }
        }
    },
    methods: {
        CartWallHangingAdd() {
            this.$refs.GetWallHanging.Cart_WallHanging_Add();
        },
        CartControlCabinetPackageAdd() {
            this.$refs.ControlCabinet.Cart_ControlCabinetPackage_Add();
        },

        // 获取打包订单报价单类型
        getCheckSPCOrderCreate() {
            this.$newsApi.order.getCheckSPCOrderCreate().then((res) => {
                if (res.data.Resultcode == 0) {
                    this.orderTypeList = res.data.data;
                }
            });
        },
        // 打包订单报价单类型改变
        changeSPCOrderCreate() {
            this.orderTypeList.forEach((item, index) => {
                if (this.Orders_Type == item.ID) {
                    if (item.tip) {
                        this.$message.warning(item.tip);
                    }
                }
            });
        },
        /*
        客户选择
        */
        async getCheckCustomerAndCustomerSub() {
            this.sub_customerInfor = {};
            this.CustomerSub_Name = '';
            let result = { Orders_Type: this.Orders_Type, Customer_Type: this.Customer_Type };
            if (this.Customer_Type == 0) {
                result = {
                    ...result,
                    Customer_ID: 0,
                    Customer_Name: this.Customer_Name
                };
            } else {
                result = {
                    ...result,
                    Person_Name: this.Person_Name,
                    Person_Mobile: this.Person_Mobile
                };
            }
            let res = await this.$newsApi.order.getCheckCustomerAndCustomerSub(result);
            if (res.data.Resultcode == 0 && res.data.data != null) {
                console.log('res.data.data', res.data.data);
                this.Customer_info = res.data.data;
                if (this.Customer_Type == 0) {
                    this.Customer_info.Customer_Name = this.Customer_Name;
                } else {
                    this.Customer_info.Customer_Name = this.Person_Name;
                }
                await this.getOfficeCustomerARAmount(this.Customer_info.Customer_Code);
                await this.GetCreditCustomerRisk(this.Customer_info.Customer_Code, this.Customer_info.Customer_Name);
                if (this.Customer_Type == 0 && this.Customer_info.customer_islimit == '1') {
                    this.$confirm('此客户为受限客户，将触发BPM审核流程！', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    })
                        .then(() => {
                            // this.currentCustomerInfor.Pipeline_ID = this.currentPipelineInfor[this.currentPipelineId].opportunityName
                            // 	this.currentCustomerInfor.Apply_ID = this.currentPipelineInfor[this.currentPipelineId].ID
                            // 	this.currentCustomerInfor.currentPipelineList = this.currentPipelineInfor[this.currentPipelineId]
                        })
                        .catch(() => {
                            location.reload();
                        });
                } else {
                    // this.currentCustomerInfor.Pipeline_ID = this.currentPipelineInfor[this.currentPipelineId].opportunityName
                    // this.currentCustomerInfor.Apply_ID = this.currentPipelineInfor[this.currentPipelineId].ID
                    // this.currentCustomerInfor.currentPipelineList = this.currentPipelineInfor[this.currentPipelineId]
                }
            }
        },
        //二级客户查询
        chooseCustomerInfor() {
            if (!this.CustomerSub_Name) {
                this.$message({
                    type: 'warning',
                    message: '二级客户名称不能为空'
                });
                return;
            }
            this.$newsApi.order
                .getCheckCustomerAndCustomerSub({
                    Orders_Type: this.Orders_Type, //订单类型
                    Customer_Type: this.Customer_Type, //客户类型
                    Customer_ID: this.Customer_info.Customer_ID, //客户ID
                    Customer_Name: this.Customer_info.Customer_Name, //客户名称
                    Customer_Sub_ID: 0, //二级客户ID
                    CustomerSub_Name: this.CustomerSub_Name, //二级客户名称
                    OrdersID: 0
                })
                .then((res) => {
                    if (res.data.Resultcode == 0) {
                        this.sub_customerInfor = res.data.data;
                    } else {
                        this.sub_customerInfor = {};
                    }
                });
        },
        onChange(e) {
            // 每次切换重置
            // this.Customer_info = {};
            // this.Customer_ID = '';
            // this.Customer_Name = '';
            // this.Person_Name = '';
            // this.Person_Mobile = '';
            // this.CustomerSub_Name = '';
        },
        historyChange() {
            const object = this.Orders_Customer.find((item) => item.Orders_CustomerID == this.Customer_ID);
            if (object) {
                this.Customer_Name = object.Customer_Name;
                this.getCheckCustomerAndCustomerSub();
            }
        },
        // 获取客户信用
        async getOfficeCustomerARAmount(e) {
            const result = await this.$newsApi.order.getOfficeCustomerARAmount({
                CustomerCode: e || ''
            });
            //alert(result.data.Resultinfo);
            if (result.data.data) {
                this.OfficeCustomer = [{ ...result.data.data }];
            } else {
                this.OfficeCustomer = [];
            }
        },
        // 获取客户被执行信息
        async GetCreditCustomerRisk(e, i) {
            const result = await this.$newsApi.order.GetCreditCustomerRisk({
                CustomerCode: e || '',
                Customer_name: i || ''
            });
            //alert(result.data.Resultinfo);
            if (result.data.data) {
                this.CreditCustomer = [{ ...result.data.data }];
            } else {
                this.CreditCustomer = [];
            }
        },
        handleClick(e) {
            const r = this.activeName;
            if (r == 1) {
                return;
            }
            if (r == 2) {
                this.getAllCategory();
                this.getDiscountCategorys();
                this.getSaleGroups();
                this.cartProductList();
            }
            if (r == 3) {
                // 控制柜配置
                this.$refs.ControlCabinet.GetControlCabinetProductModel();
                this.$refs.ControlCabinet.GetControlCabinetProductCanbinet();
            }
            if (r == 4) {
                this.$refs.GetWallHanging.GetModel();
                // this.GetWallHangingForm();
            }
            if (r == 5) {
                this.GetPromotionActivitys();
                this.getDiscountCategorys();
                this.cartActivityProductList();
            }
        },
        handleChange() {},
        /*
        获取商机客户列表
        */
        get_PipelineApply_SearchList() {
            const loadingInstance = this.$loading(); // 显示 loading
            this.$newsApi.order
                .get_PipelineApply_SearchList({
                    Pipeline_Key: this.Pipeline_Key,
                    Orders_Type: this.Orders_Type
                })
                .then((res) => {
                    if (res.data.Resultcode == 0) {
                        this.dialogVisible = true;
                        this.PipelineList = res.data.data;
                    }
                })
                .finally(() => {
                    this.$closeLoading(loadingInstance); // 关闭 loading
                });
        },
        confirmelection(type) {
            if (type == 'Pipeline') {
                if (this.PipelineId == 0) {
                    this.$message.warning('请选择项目');
                    return;
                }
                this.dialogVisible = false;
            }
            if (type == 'spc') {
                if (this.spcId == 0) {
                    this.$message.warning('请选择报价单');
                    return;
                }
                this.$confirm('是否选择当前客户进行下一步操作？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                    .then(() => {
                        this.dialogVisibleSpc = false;
                    })
                    .catch(() => {
                        this.spcId = 0;
                    });
            }
        },
        // 取消弹窗
        cancelDialog(type) {
            if (type == 'Pipeline') {
                this.dialogVisible = false;
                this.PipelineId = 0;
            }
            if (type == 'spc') {
                this.dialogVisibleSpc = false;
                this.spcId = 0;
            }
        },
        // 获取商关联报价单
        getSPCOrderRelationSpcApply() {
            const loadingInstance = this.$loading(); // 显示 loading
            this.$newsApi.order
                .getSPCOrderRelationSpcApply({
                    ordersn: this.Customer_info.spc_keyword
                })
                .then((res) => {
                    if (res.data.Resultcode == 0) {
                        this.dialogVisibleSpc = true;
                        this.spcList = res.data.data;
                    }
                })
                .finally(() => {
                    this.$closeLoading(loadingInstance); // 关闭 loading
                });
        },
        /*获取历史客户列表*/
        getHistoryCustomerList() {
            this.$newsApi.order.getHistoryCustomerList().then((res) => {
                 //alert(res.data.Resultinfo);
                if (res.data.Resultcode == 0) {
                    this.Orders_Customer = res.data.data;
                }
            });
        },
        // 获取常用商品
        async cartProductCommonList() {
            const result = await this.$newsApi.order.getCartProductCommonList({
                Orders_type: this.Orders_type,
                json: {}
            });
            if (result.data.data) {
                result.data.data.map((item) => {
                    (item.userDefinedNum = 0), (item.checkBox = false);
                });
                this.productCommonList = result.data.data;
                this.$nextTick(() => {
                    // 或者选中所有行
                    if (this.$refs.productCommonTable) {
                        this.productCommonList.forEach((row) => {
                            this.$refs.productCommonTable.toggleRowSelection(row, true);
                        });
                    }
                });
            } else {
                this.productCommonList = [];
            }
        },
        // 获取商品分类
        async getAllCategory(e) {
            let result = await this.$newsApi.getAllCategory();
            let arr = result.data.data.filter((item) => item.Cate_ParentID == 0);
            this.Product_cate_parentList = [{ Cate_Name: '全部分类', Cate_ID: 0 }].concat(arr);
            this.AllCategoryList = result.data.data;
        },
        // 获取商品销售类型
        async getDiscountCategorys() {
            let result = await this.$newsApi.getDiscountCategorys();
            this.Product_cate_DiscountList = [{ Name: '全部折扣分组', ID: 0 }].concat(result.data.data);
        },
        // 获取销售组
        async getSaleGroups() {
            let result = await this.$newsApi.order.getSaleGroups();
            this.Product_cate_SaleGroupIDList = [{ SaleGroup_Name: '全部销售组', SaleGroup_ID: 0 }].concat(result.data.data);
            this.activity_cate_SaleGroupIDList = [{ SaleGroup_Name: '全部销售组', SaleGroup_ID: 0 }].concat(result.data.data);
        },
        // 获取促销活动
        async GetPromotionActivitys() {
            try {
                var result = await this.$newsApi.order.GetPromotionActivitys();
                // 检查返回数据是否有效
                if (result && result.data && result.data.data && Array.isArray(result.data.data)) {
                    // 过滤掉null或undefined的项目
                    const validData = result.data.data.filter(item => item && item.Promotion_Activity_ID !== null && item.Promotion_Activity_ID !== undefined);
                    this.activityAmountList = [{ Promotion_Activity_ID: -1, Promotion_Activity_Title: '选择活动' }].concat(validData);
                } else {
                    // 如果没有有效数据，只保留默认选项
                    this.activityAmountList = [{ Promotion_Activity_ID: -1, Promotion_Activity_Title: '选择活动' }];
                }
            } catch (error) {
                console.error('获取促销活动失败:', error);
                // 出错时保持默认选项
                this.activityAmountList = [{ Promotion_Activity_ID: -1, Promotion_Activity_Title: '选择活动' }];
            }
        },
        // 普通商品列表
        async cartProductList(e) {
            if (e) {
                this.productListOptions = {
                    PageSize: 40,
                    Page: 1,
                    total: 0
                };
                this.productList = [];
                this.hasMoreData = true;
                this.noMoreData = false;
            }

            if (this.loadingMore || !this.hasMoreData) {
                return;
            }

            this.loadingMore = true;
            let jsonData = { ...this.serch_productList, promotionid: 0, IsActivity: 0 };
            jsonData = JSON.stringify(jsonData);

            try {
                let result = await this.$newsApi.order.getCartProductList({
                    Orders_type: this.Orders_type,
                    Json: jsonData,
                    Page: this.productListOptions.Page,
                    PageSize: this.productListOptions.PageSize
                });

                if (result.data.data && result.data.data.length > 0) {
                    // 添加默认数量属性
                    result.data.data.map((item) => {
                        (item.userDefinedNum = 0), (item.checkBox = true);
                    });

                    // 瀑布流加载：如果不是第一页，为新数据添加分隔线标识
                    if (this.productListOptions.Page > 1 && result.data.data.length > 0) {
                        result.data.data[0].isNewBatch = true;

                        // 记录当前滚动位置
                        const container = this.$refs.tableContainer;
                        const scrollTop = container ? container.scrollTop : 0;

                        // 添加新数据
                        this.productList = this.productList.concat(result.data.data);

                        // 恢复滚动位置，让滚动条离开底部
                        this.$nextTick(() => {
                            if (container) {
                                container.scrollTop = scrollTop - 50;
                            }
                        });
                    } else {
                        // 第一页数据直接赋值
                        this.productList = result.data.data;
                    }

                    this.productListOptions.total = result.data.total;

                    // 检查是否还有更多数据
                    if (result.data.data.length < this.productListOptions.PageSize) {
                        this.hasMoreData = false;
                        this.noMoreData = true;
                    }

                    this.$nextTick(() => {
                        // 选中所有行
                        if (this.$refs.productListTable) {
                            this.productList.forEach((row) => {
                                this.$refs.productListTable.toggleRowSelection(row, true);
                            });
                        }
                    });
                } else {
                    if (this.productListOptions.Page === 1) {
                        this.productList = [];
                    }
                    this.hasMoreData = false;
                    this.noMoreData = true;
                }
            } catch (error) {
                console.error('加载商品列表失败:', error);
            } finally {
                this.loadingMore = false;
            }
        },
        // 当前选中的数组
        handleSelectionChange(value) {
            this.activeShopList = value;
        },
        // 滚动事件处理
        handleScroll(event) {
            const { scrollTop, scrollHeight, clientHeight } = event.target;
            // 当滚动到底部附近时加载更多数据
            if (scrollHeight - scrollTop - clientHeight < 100 && this.hasMoreData && !this.loadingMore) {
                this.productListOptions.Page++;
                this.cartProductList();
            }
        },
        // 获取行样式类名
        getRowClassName({ row, rowIndex }) {
            if (row.isNewBatch) {
                return 'new-batch-row';
            }
            return '';
        },
        /*下一步*/
        async onNext() {
            switch (this.next) {
                case 1:
                    // 如果是个人客户需要手动检查
                    if (this.Customer_Type == 1) {
                        var reg = /^[1](([3][0-9])|([4][0,1,4-9])|([5][0-3,5-9])|([6][2,5,6,7])|([7][0-8])|([8][0-9])|([9][0-3,5-9]))[0-9]{8}$/; //手机号验证规则
                        if (this.Person_Name == '') {
                            this.$message.warning('请输入客户姓名');
                            return;
                        } else if (this.Person_Mobile == '') {
                            this.$message.warning('请输入客户手机号');
                            return;
                        } else if (!reg.test(this.Person_Mobile)) {
                            this.$message.warning('客户手机号格式错误');
                            return;
                        } else {
                            await this.getCheckCustomerAndCustomerSub();
                            this.saveCustomerInfo();
                            this.next++;
                        }
                    } else {
                        this.isNeedAddCustomerSub();
                    }
                    break;

                case 2: {
                    // 支付方式
                    let result = await this.$refs.Payment.nextStep();
                    this.submitpaymentObj = result;
                    if (this.applyId) {
                        await this.$newsApi.order.Office_SetSPCApplyGoods_To_GoodsTmp({
                            spcapply_id: this.applyId,
                            spcapply_sn: '',
                            buyerid: this.customerInfor.Member_ID,
                            customer_id: this.Customer_ID,
                            customer_subid: this.customerInfor.Customer_Sub_ID || 0
                        });
                    }
                    else
                    {
                         await this.$newsApi.order.Office_SetSPCApplyGoods_To_GoodsTmp({
                            spcapply_id: 0,
                            spcapply_sn: '',
                            buyerid: this.customerInfor.Member_ID,
                            customer_id: this.Customer_ID,
                            customer_subid: this.customerInfor.Customer_Sub_ID || 0
                        });
                    }

                    console.log('submitpaymentObj', this.submitpaymentObj);
                    if (!result) {
                        this.submitpaymentObj = {
                            id: '',
                            value: '',
                            needPayCode: ''
                        };
                    }
                    this.cartProductCommonList();
                    this.UpdateCartSession();
                    this.next++;
                    this.cartProductCountAmount();
                    break;
                }
                case 5:
                    this.OrdersCreate({ name: '下一步', type: 1 });
                    break;
            }
        },
        // 更新购物车sessionid
        async UpdateCartSession() {
            var result = await this.$newsApi.order.UpdateCartSession({
                orders_buyerid: this.customerInfor.Member_ID,
                orders_id: this.orders_id,
                tradetype: this.TradeType
            });
        },
        // 下一步点击之前校验
        beforeNextCheck() {
            let Orders_Type = this.Orders_Type.toString();
            if (!Orders_Type) {
                this.$message.warning('请选择订单类型');
                return;
            }
            // if (!this.Customer_info.Customer_Code) {
            //     console.log(this.customerInfor);
            //     this.$message.warning('请选择客户');
            //     return;
            // }
            return true;
        },
        //是否需要添加二级客户
        isNeedAddCustomerSub() {
            if (!this.beforeNextCheck()) {
                return;
            }
            this.saveCustomerInfo();
            if (this.Orders_Type == 0 && this.customerInfor.CustomerSubs == true) {
                this.$confirm('是否选择二级客户？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '否',
                    type: 'warning'
                })
                    .then(() => {
                        this.$message({
                            type: 'warning',
                            message: '暂不支持选择二级客户'
                        });
                    })
                    .catch(() => {
                        this.next++;
                    })
                    .finally(() => {});
            } else {
                this.next++;
            }
        },
        // 储存当前选择的客户信息
        saveCustomerInfo() {
            console.log('Customer_info', this.Customer_info);
            this.customerInfor = cloneDeep({
                ...this.Customer_info,
                TradeType: this.TradeType,
                Orders_type: this.Orders_Type
            });
        },
        //添加购物车
        async getopenControlAdd() {
            let obj = {};
            var shopList = [];
            let IsActivity = 0;
            if (this.activeName == 1) {
                // shopList = this.productCommonList;
            } else if (this.activeName == 2) {
                // shopList = this.productList;
            } else if (this.activeName == 5) {
                if (this.TradeType == 2 && this.$store.state.saleType == 1) {
                    // shopList = this.promotionProductList;
                } else {
                    // shopList = this.activityProductList;
                    IsActivity = 1;
                }
            }
            for (let i = 0; i < this.activeShopList.length; i++) {
                let currentObj = this.activeShopList[i];
                if (currentObj.userDefinedNum > 0) {
                    obj[currentObj.Product_ID] = currentObj.userDefinedNum;
                }
            }
            if (JSON.stringify(obj) == '{}') {
                this.$message.warning('请您选择商品并添加数量');
            } else {
                const loadingInstance = this.$loading(); // 显示 loading
                obj = JSON.stringify(obj);
                var result = await this.cartProductBatchAdd(obj, IsActivity);
                this.$closeLoading(loadingInstance); // 关闭 loading
                if (result.data.resultcode == 0) {
                    this.$message.success(result.data.resultinfo);
                    this.cartProductCountAmount();
                }
            }
        },
        // 购物车请求
        async cartProductBatchAdd(e, isactivity) {
            let dataObj = {
                orders_type: this.Orders_Type, //订单类型
                customer_id: this.customerInfor.Customer_ID || 0, //客户ID
                customer_subid: this.customerInfor.Customer_Sub_ID || 0, //二级客户ID
                buyerid: this.customerInfor.Member_ID,
                sessionid: '',
                tradetype: this.TradeType,
                json: e,
                orders_id: this.orders_id,
                ordersourcecate: this.Orders_SourceCate,
                isactivity
            };
            const result = await this.$newsApi.order.cartProductBatchAdd(dataObj);
            return result;
        },
        // 获取购物车列表
        async searchShoppingCart(e) {
            let loadingInstance = this.$loading(); // 显示 loading
            var result = await this.$newsApi.order.OrdersGoodsList({
                orders_id: this.orders_id,
                orders_buyerid: this.customerInfor.Member_ID,
                orders_type: this.Orders_Type,
                tradetype: this.TradeType,
                spcapply_id: '',
                sessionid: '',
                good_id: e ? e.Goods_ID : ''
            });
            this.$closeLoading(loadingInstance); // 关闭 loading
            if (result.data.Resultcode == 0) {
                if (this.next < 4) {
                    this.next++;
                }
                if (result.data.data) {
                    result.data.data.map((item) => {
                        item.checked = false;
                        item.Goods_Product_Name = item.Goods_Product_Name;
                        item.Goods_IsInsale = item.Goods_IsInsale == 1 ? '是' : '否';
                    });
                    this.Twlist = result.data.data;
                } else {
                    this.Twlist = [];
                }
                // 添加默认选中属性

                this.countPrice();
            } else {
                this.Twlist = [];
            }
            if (result.data.Resultinfo) {
                this.$message.warning(result.data.Resultinfo);
                return;
            }
        },
        countPrice() {
            var array = this.Twlist;
            var price = 0;
            var commitArray = [];
            var needCreatedNum = 0;
            for (let i = 0; i < array.length; i++) {
                price += array[i].Goods_Amount * array[i].Goods_Product_Price;
                commitArray.push(array[i]);
                if (array[i].IsOffer == '否') {
                    needCreatedNum++;
                }
            }
            needCreatedNum == array.length ? (this.createdShow = true) : (this.createdShow = false);
            this.allCartPrice = price.toFixed(2);
        },
        // 列表删除编辑按钮
        allDelete() {
            this.$confirm('您确定一键清空购物车吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '否',
                type: 'warning'
            })
                .then(async () => {
                    const loadingInstance = this.$loading(); // 显示 loading
                    this.nowCartId = this.Twlist.map((item) => item.Goods_ID);
                    var result = await this.deleteShop();
                    this.$closeLoading(loadingInstance); // 关闭 loading
                    if (result.resultcode == 0) {
                        this.$message.success(result.resultinfo);
                    }
                    setTimeout(() => {
                        this.searchShoppingCart();
                        this.allPrice = 0;
                    }, 1000);
                })
                .catch(() => {})
                .finally(() => {});
        },
        listDelete(e) {
            this.$confirm('您确定要删除当前商品吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '否',
                type: 'warning'
            })
                .then(async () => {
                    this.nowCartId = e;
                    var result = await this.deleteShop();
                    if (result.resultcode == 0) {
                        this.$message.success(result.resultinfo);
                    }
                    setTimeout(() => {
                        this.searchShoppingCart();
                        this.allPrice = 0;
                    }, 1000);
                })
                .catch(() => {})
                .finally(() => {});
        },
        // 删除购物车商品
        async deleteShop() {
            var coods = this.nowCartId.join();
            var result = await this.$newsApi.order.officeCartGoodstmpDel({
                orders_id: this.orders_id,
                orders_buyerid: this.customerInfor.Member_ID,
                orders_type: this.Orders_Type,
                tradetype: this.TradeType,
                SessionID: '',
                good_id: coods
            });
            return result;
        },
        // 购物车商品是否在销售中
        async cartProductIsInsaleCount() {
            let ordersId = this.changeOrderType == 0 ? this.orders_id : '-1';
            var result = await this.$newsApi.order.cartProductIsInsaleCount({
                Orders_buyerID: this.customerInfor.Member_ID,
                TradeType: this.TradeType,
                orders_id: ordersId,
                Orders_type: this.Orders_Type
            });
            return result;
        },
        // 跳转创建报价单页面
        async goSubmit(e) {
            if (!this.Twlist || this.Twlist.length === 0) {
                this.$message.warning('购物车没有商品，请先添加商品');
                return;
            }
            let result = await this.cartProductIsInsaleCount();
            if (result.data.Resultcode == 1) {
                return;
            }
            this.isini = true;
            this.next++;
        },
        // 报价单采购清单
        async OrdersSPCConfirm_Goods_List(e, i) {
            this.$refs.SubmitSpcOrder.GetBranchOfficeByID();
            let json = '';
            if (e == '折扣') {
                json = JSON.stringify(this.discountObj);
            } else {
                json = JSON.stringify(e);
            }
            let BillObj = {};
            if (i) {
                BillObj = {
                    ifBack: true
                };
            } else {
                BillObj = {
                    isini: this.isini
                };
            }
            let ordersId = this.orders_id;
            var result = await this.$newsApi.order.OrdersSPCConfirm_Goods_List({
                ...BillObj,
                json: json || {},
                ispreview: this.ispreview,
                orders_type: this.Orders_Type,
                orders_buyerid: this.customerInfor.Member_ID,
                ordersourcecate: this.Orders_SourceCate, //报价单来源类型
                customerid: this.customerInfor.Customer_ID, //客户ID
                customersubid: this.customerInfor.Customer_Sub_ID, //二级客户ID
                tradetype: this.TradeType,
                isconfirm: this.isconfirm,
                orders_id: -1,
                ppipeline_id: ''
            });
            this.isini = false;
            if (result.data.data) {
                if (i) {
                    if (result.data.data.NormalList) {
                        result.data.data.NormalList.map((items) => {
                            items.Goods.map((itemChildren) => {
                                itemChildren.checked = true;
                            }),
                                (items.inputValue = '');
                        });
                        this.confirmCartList = result.data.data.NormalList;
                    }
                    if (result.data.data.ActivityList) {
                        result.data.data.ActivityList.map((items) => {
                            items.Goods.map((itemChildren) => {
                                itemChildren.checked = true;
                            }),
                                (items.inputValue = '');
                        });
                        this.confirmActivityCartList = result.data.data.ActivityList;
                    }
                } else {
                    if (result.data.data.NormalList) {
                        result.data.data.NormalList.map((items) => {
                            items.Goods.map((itemChildren) => {
                                itemChildren.checked = true;
                            }),
                                (items.inputValue = '');
                        });
                        this.cartList = result.data.data.NormalList;
                    }
                    if (result.data.data.ActivityList) {
                        result.data.data.ActivityList.map((items) => {
                            items.Goods.map((itemChildren) => {
                                itemChildren.checked = true;
                            }),
                                (items.inputValue = '');
                        });
                        this.activityCartList = result.data.data.ActivityList;
                    }
                }
                this.cartgoods = result.data.Resultinfo;
                let cartListArr = [];
                if (i) {
                    cartListArr = this.confirmCartList.concat(this.confirmActivityCartList);
                } else {
                    cartListArr = this.cartList.concat(this.activityCartList);
                }
                for (let item of cartListArr) {
                    if (item.Remark) {
                        this.$message.warning(item.Remark);
                    }
                    for (let towMenus of item.Goods) {
                        if (towMenus.Remark) {
                            this.$message.warning(towMenus.Remark);
                        }
                    }
                }
            }
        },
        // 计算折扣
        computerMethods(obj) {
            var needObj = this.createdObj();
            for (var key in obj) {
                needObj[key] = obj[key];
            }
            this.discountObj = needObj;
            this.OrdersSPCConfirm_Goods_List('折扣');
        },
        // 序列化对象
        createdObj() {
            var obj = {};
            obj.Orders_type = this.Orders_Type;
            obj.Orders_SourceCate = this.Orders_SourceCate;
            obj.SPCApply_ID = 0;
            obj.SPCApply_BillType = 0; //价单状态 正式为1 临时为0
            obj.orders_copy = this.orders_copy; //是否复制 0为否 1为是

            obj.orders_target = 1; //0保存 1提交

            obj.cartgoods = this.cartgoods || ''; //商品清单列表获取的数据

            obj.Orders_PayType_ID = this.submitpaymentObj.id; //付款方式ID
            obj.paytype_name = this.submitpaymentObj.value || this.submitpaymentObj.name; //付款方式名称
            obj.prepay_percent = this.submitpaymentObj.needPayCode.prepay_percent; //预付比例	浮点型
            obj.nextpay_days = this.submitpaymentObj.needPayCode.nextpay_days; //付款期
            obj.second_percent = this.submitpaymentObj.needPayCode.second_percent; //二期预付比例
            obj.second_days = this.submitpaymentObj.needPayCode.secondpay_days; //调试付款期
            obj.third_percent = this.submitpaymentObj.needPayCode.third_percent; //尾款比例
            obj.retention_percent = this.submitpaymentObj.needPayCode.retention_percent; //剩余比例
            obj.Expired_PayDate = this.submitpaymentObj.needPayCode.Expired_PayDate; //最迟结算日期

            obj.Orders_BuyerID = this.customerInfor.Member_ID; //会员ID
            obj.member_id = this.customerInfor.Member_ID; //会员ID
            obj.customer_id = this.customerInfor.Customer_ID; //客户ID
            obj.Customer_Sub_ID = this.customerInfor.Customer_Sub_ID || ''; //二级客户ID
            obj.Customer_Name = this.customerInfor.Customer_Name; //客户名称
            obj.Customer_Mobile = this.customerInfor.Customer_Mobile || ''; //客户手机

            if (this.customerInfor.Customer_Type == 1) {
                obj.Customer_Name = this.customerInfor.Person_Name;
                obj.Customer_Mobile = this.customerInfor.Person_Mobile;
            }
            let spcOrderinfo = this.$refs.SubmitSpcOrder.getFormParams();
            obj.Customer_Project_Country = '1'; //项目国家
            obj.Customer_Project_State = spcOrderinfo.Customer_Project_State; //项目省份
            obj.Customer_Project_City = spcOrderinfo.Customer_Project_City; //项目市
            obj.Customer_Project_County = spcOrderinfo.Customer_Project_County; //项目区
            obj.Customer_Project_Name = spcOrderinfo.Customer_Project_Name; //主体项目名称
            obj.Orders_ProjectType_ID = spcOrderinfo.Orders_ProjectType_ID_Three ? spcOrderinfo.Orders_ProjectType_ID_Three : spcOrderinfo.Orders_ProjectType_ID_Two ? spcOrderinfo.Orders_ProjectType_ID_Two : spcOrderinfo.Orders_ProjectType_ID; //项目类型ID

            obj.SPCApply_OfficeManID = spcOrderinfo.Orders_OfficeManID; //业务员id
            obj.SPCApply_OfficeManName = spcOrderinfo.Orders_OfficeManName; //业务员名字
            obj.officeInfoDetail = spcOrderinfo.officeInfoDetail;

            obj.SPCApply_PlanDeliveryDays = spcOrderinfo.SPCApply_PlanDeliveryDays; //预计供货时间

            obj.Orders_ProjectNote = ''; //项目说明
            obj.SessionID = '';
            return obj;
        },
        // 检查
        async OrdersCreate() {
            var json = this.createdObj();

            // 提取购物车折扣价参数
            var list = this.cartList.concat(this.activityCartList);
            var obj = {};
            for (let i = 0; i < list.length; i++) {
                for (let j = 0; j < list[i].Goods.length; j++) {
                    obj['discountprice_' + list[i].Goods[j].Goods_ID] = list[i].Goods[j].Goods_Product_AdjustDiscountPrice;
                }
            }
            // 将obj合并到 jsonObj里面
            for (var key in obj) {
                json[key] = obj[key];
            }

            if (this.applyId && this.orders_copy != 1) {
                json.SPCApply_ID = this.applyId;
            }
            json = JSON.stringify(json);
            let loadingInstance = this.$loading(); // 显示 loading
            var result = await this.$newsApi.order.SPCApply_Create({
                json: json
            });
            this.$closeLoading(loadingInstance); // 关闭 loading
            result = result.data;
            if (result.Resultcode == 0) {
                if (result.Resultinfo.indexOf('[noprice]') == -1) {
                    await this.CheckCartmethods(json);
                } else {
                    this.$confirm(result.Resultinfo.split('[noprice]')[1], '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '否',
                        type: 'warning'
                    }).then(async () => {
                        await this.CheckCartmethods(json);
                    });
                }
            }
        },
        // 建测是否有特价信息
        async CheckCartmethods(json) {
            let resultCheck = await this.$newsApi.order.CheckCartIsSpecialPrice(json);
            resultCheck = resultCheck.data;
            let jsonObj = JSON.parse(json);
            if (!resultCheck.data) {
                // 特价信息为空
                let specialOfferjson = {
                    Special_FutureScale: '', //合作规模
                    Special_FutureAvgDiscount: '', //A类预期平均折扣
                    Special_FutureAvgDiscountB: '', //B类预期平均折扣
                    Special_IsNewCustomer: null, //是否新用户
                    Special_CustomerIntro: '', //客户简介
                    Special_BusinessIntro: '', //业务背景
                    Special_Competitor: '', //竞争对手信息
                    Special_IsMoreTermsPlan: '', //多期开发规划
                    Special_IsNoLow: '', //折扣仅适用于此项目
                    Special_Start: '', //开始有效期
                    Special_End: '', //结束有效期
                    Special_Type: '', //特价处理
                    Special_IsPaper: '', //是否根据图纸预估销售额
                    Special_IsSourceDiscountFreight: '', //原折扣率发货
                    Special_ExpertRate: 0, //项目是否为独家专供
                    Special_LaterFreightAmount: 0 //库存订单未来发货金额
                };
                jsonObj = JSON.parse(json);
                Object.assign(jsonObj, specialOfferjson);
            }
            this.comfirmSpcOrder(jsonObj);
        },
        // 报价单确认页面方法
        async comfirmSpcOrder(orderInfo) {
            let nameInfo = this.$refs.SubmitSpcOrder.getNameMethods();
            orderInfo = { ...orderInfo, ...nameInfo };
            await this.OrdersSPCConfirm_Goods_List(orderInfo, 1);
            this.next++;
            // 这里需要等待comfirmSpcOrderMethos组件加载完成
            this.$nextTick(async () => {
                this.$refs.ConfirmSpcOrder.comfirmSpcOrderMethos(orderInfo);
                // 同时更新SubmitQuatation组件的订单信息
                if (this.$refs.SubmitQuatation) {
                    this.$refs.SubmitQuatation.comfirmSpcOrderMethos(orderInfo);
                }
                this.ispreview = true;
                this.isconfirm = true;
            });
        },
        // 确认报价单并提交
        async confirmOrdersCreate(e) {
            let json = this.$refs.ConfirmSpcOrder.getSpcOrderConfirmParams();
            e == '保存' ? (json.orders_target = 0) : (json.orders_target = 1);
            json.Pipeline_ID = '';
            // 提取购物车折扣价参数
            let list = this.cartList.concat(this.activityCartList);
            for (let i = 0; i < list.length; i++) {
                for (let j = 0; j < list[i].Goods.length; j++) {
                    if (list[i].Goods[j].Goods_IsSaveOrder >= 0) {
                        json['IsSaveOrder_' + list[i].Goods[j].Goods_ID] = list[i].Goods[j].checked ? list[i].Goods[j].Goods_ID : 0; //选中的商品
                    }
                }
            }
            if (this.applyId) {
                json.SPCApply_ID = this.applyId;
            }
            json = JSON.stringify(json);
            const loadingInstance = this.$loading(); // 显示 loading
            var result = await this.$newsApi.order.SPCApply_Create({
                json: json
            });
            this.$closeLoading(loadingInstance); // 关闭 loading
            result = result.data;
            if (result.Resultcode == 0) {
                this.$message.success(e + '报价单成功！');
                // 跳转到订单页
                this.resetDataMy();
                setTimeout(() => {
                    this.$router.push({ path: '/quotationManagement/index', query: { t: Date.now() } }); // 替换当前路由
                }, 500);
            }
        },
        // 购物车商品数量
        async cartProductCountAmount() {
            var result = await this.$newsApi.order.cartProductCountAmount({
                orders_buyerid: this.customerInfor.Member_ID,
                tradetype: this.TradeType,
                orders_id: this.orders_id,
                orders_type: this.Orders_Type
            });
            if (result.data.Resultcode == 0) {
                this.shoppingCarts = result.data.data;
            }
        },
        // 柜台加入购物车
        async Cart_ControlCabinetPackage_Add(e) {
            let dataObj = {
                ...e,
                Orders_Type: this.Orders_Type, //订单类型
                customerid: this.customerInfor.Customer_ID || 0, //客户ID
                customersubid: this.customerInfor.Customer_Sub_ID || 0, //二级客户ID
                Orders_buyerID: this.customerInfor.Member_ID,
                TradeType: this.TradeType,
                Orders_ID: this.orders_id,
                Orders_SourceCate: this.Orders_SourceCate
            };
            let json = JSON.stringify(dataObj);
            let loadingInstance = this.$loading(); // 显示 loading
            let result = await this.$newsApi.order.Cart_ControlCabinetPackage_Add({ json: json });
            this.$closeLoading(loadingInstance); // 关闭 loading
            if (result.data.Resultcode == 0) {
                this.$message.success(result.data.Resultinfo);
                this.cartProductCountAmount();
            }
        },
        async Cart_WallHanging_Add(e) {
            let dataObj = {
                ...e,
                Orders_Type: this.Orders_Type, //订单类型
                customerid: this.customerInfor.Customer_ID || 0, //客户ID
                customersubid: this.customerInfor.Customer_Sub_ID || 0, //二级客户ID
                Orders_buyerID: this.customerInfor.Member_ID,
                TradeType: this.TradeType,
                Orders_ID: this.orders_id,
                Orders_SourceCate: this.Orders_SourceCate
            };
            let json = JSON.stringify(dataObj);
            let loadingInstance = this.$loading(); // 显示 loading
            let result = await this.$newsApi.order.Cart_WallHanging_Add({ json: json });
            this.$closeLoading(loadingInstance); // 关闭 loading
            if (result.data.Resultcode == 0) {
                this.$message.success(result.data.Resultinfo || '添加成功');
                this.cartProductCountAmount();
            }
        },
        async officeCartGoodstmpEdit(e) {
            this.cartEditing = true;
            let obj = {
                Orders_id: this.orders_id,
                Orders_buyerID: this.customerInfor.Member_ID,
                Orders_Type: this.Orders_Type,
                TradeType: this.TradeType,
                SessionID: '',
                Customer_ID: this.customerInfor.Customer_ID, //客户ID
                Customer_SubID: this.customerInfor.Customer_Sub_ID || 0, //二级客户ID
                Good_id: e.Goods_ID,
                Buyamount: e.Goods_Amount
            };
            let result = await this.$newsApi.order.Office_Cart_Goodstmp_Edit(obj);
            if (result.data.resultcode == 0) {
                // this.$message.success(result.data.resultinfo);
                this.searchShoppingCart(e);
            }
            this.cartEditing = false;
        },
        // 导入excel
        importExcel() {
            this.carExexlFilepath = '';
            this.importExcelShow = true;
        },
        // 导出excel
        async importCartGoods() {
            let json = JSON.stringify({ filepath: this.carExexlFilepath });
            let obj = {
                OrdersID: -1,
                Orders_buyerID: this.customerInfor.Member_ID,
                CustomerID: this.customerInfor.Customer_ID,
                CustomerSubID: this.customerInfor.SPCApply_CustomerSubID,
                OrderType: this.Orders_Type,
                TradeType: this.TradeType,
                json: json
            };
            this.$confirm('此操作将清空当前购物车中所有非促销的现场设备，仅保留配置好的主机设备及促销商品！', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '否',
                type: 'warning'
            }).then(async () => {
                const loadingInstance = this.$loading(); // 显示 loading
                let result = await this.$newsApi.order.ImportCartGoods(obj);
                if (result.data.Resultcode == 0) {
                    await this.searchShoppingCart();
                    this.$closeLoading(loadingInstance); // 关闭 loading
                    this.importExcelShow = false;
                    this.$message.success(result.data.Resultinfo);
                }
            });
        },
        // 购物车上传
        onSuccessExcel(e) {
            this.carExexlFilepath = e;
        },
        // 促销活动
        async cartActivityProductList(e) {
            if (e) {
                this.activityProductListOptions = {
                    PageSize: 10,
                    Page: 1,
                    total: 0
                };
            }
            let jsonData = { ...this.activityParams, promotionid: 0, IsActivity: 1 };
            jsonData = JSON.stringify(jsonData);
            let result = await this.$newsApi.order.getCartProductList({
                Orders_type: this.Orders_type,
                Json: jsonData,
                Page: this.activityProductListOptions.Page,
                PageSize: this.activityProductListOptions.PageSize
            });
            if (result.data.data) {
                // 添加默认数量属性
                result.data.data.map((item) => {
                    (item.userDefinedNum = 0), (item.checkBox = true);
                });
                // this.productList = result.data.slice(0,10);
                this.activityProductList = result.data.data;
                this.activityProductListOptions.total = result.data.total;
                this.$nextTick(() => {
                    // 或者选中所有行
                    if (this.$refs.activityProductListTable) {
                        this.activityProductList.forEach((row) => {
                            this.$refs.activityProductListTable.toggleRowSelection(row, true);
                        });
                    }
                });
            } else {
                this.activityProductList = [];
            }
        },
        productListSizeChange(newSize) {
            this.productListOptions.PageSize = newSize;
            this.cartProductList();
        },
        productListCurrentChange(newPage) {
            this.productListOptions.Page = newPage;
            this.cartProductList();
        },
        activityListSizeChange(newSize) {
            this.activityProductListOptions.PageSize = newSize;
            this.cartActivityProductList();
        },
        activityListCurrentChange(newPage) {
            this.activityProductListOptions.Page = newPage;
            this.cartActivityProductList();
        },
        continueShopping() {
            this.next--;
            this.cartProductCommonList();
        },
        // 设置为常用设备(删除，添加)
        addeQuipment(i, e) {
            let obj = {
                Product_ID: e.Product_ID,
                Action: i
            };
            this.$newsApi.order.ProductCommonAction(obj).then((res) => {
                if (res.data.resultcode == 0) {
                    this.$message.success(res.data.resultinfo);
                    if (i == 'del') {
                        this.cartProductCommonList();
                    } else {
                        this.cartProductList();
                    }
                } else {
                    this.$message.error(res.data.resultinfo);
                }
            });
        },
        // 批量移除
        async deleterChoose() {
            const loadingInstance = this.$loading(); // 显示 loading
            if(this.nowCartList)
            {
                
            }
            else
            {
                this.$message.info("请勾选要批量删除的商品!");
                this.$closeLoading(loadingInstance); // 关闭 loading
                return;    
            }
            this.nowCartId = this.nowCartList.map((item) => item.Goods_ID);
            
            if(this.nowCartId =="")
            {
                this.$message.info("请勾选要批量删除的商品!");
                this.$closeLoading(loadingInstance); // 关闭 loading
                return;    
            }
            var result = await this.deleteShop();
            this.$closeLoading(loadingInstance); // 关闭 loading
            if (result.resultcode == 0) {
                this.$message.success(result.resultinfo);
            }
            setTimeout(() => {
                this.searchShoppingCart();
                this.allPrice = 0;
            }, 1000);
        },
        // 批量选择
        selectionChange(val) {
            this.nowCartList = val;
        },
        // 商品清单
        productExport() {
            let loadingInstance = this.$loading(); // 显示 loading
            this.$newsApi.Product_List_Export().then((res) => {
                this.$closeLoading(loadingInstance); // 关闭 loading
                if (res.data.Resultcode == 0) {
                    window.open(this.$fileUrl + res.data.data, '_blank');
                }
            });
        },
        // 商品excel
        cartExport() {
            let loadingInstance = this.$loading(); // 显示 loading
            this.$newsApi
                .Cart_List_Export({
                    BuyerID: this.customerInfor.Member_ID
                })
                .then((res) => {
                    this.$closeLoading(loadingInstance); // 关闭 loading
                    if (res.data.Resultcode == 0) {
                        if (res.data.Resultcode == 0) {
                            window.open(this.$fileUrl + res.data.data, '_blank');
                            this.$message.success('导出成功，文件已开始下载'); // 添加成功提示
                        } else {
                            this.$message.error(`导出失败: ${res.data.Resultinfo}`); // 添加失败提示
                        }
                    }
                })
                .catch((error) => {
                    this.$closeLoading(loadingInstance);
                    this.$message.error('导出请求失败' + error); // 网络错误提示
                });
        },
        // 完善订单页上一步
        goCarshop() {
            this.next--;
            // this.isini = true;
        },
        stepConfirmOrders() {
            this.ispreview = false;
            this.isconfirm = false;
            this.next = 5;
        },
        async changeOrder() {
            let spcApply;
            if (this.applyId) {
                spcApply = await this.getSPCApplyByID();
                this.SPCApplyInfo = spcApply;
                this.changePayInfoData = JSON.parse(this.SPCApplyInfo.SPCApply_PayTypeNameJson);
                this.SPCApply_PayTypeID = this.SPCApplyInfo.SPCApply_PayTypeID;
                this.SPCApply_PayTypeName = this.SPCApplyInfo.SPCApply_PayTypeName;
            }
            if (spcApply.SPCApply_CustomerID) {
                const customer = await this.getCustomerByID(spcApply.SPCApply_CustomerID);
                this.Customer_ID = spcApply.SPCApply_CustomerID;
                this.Customer_Name = spcApply.SPCApply_CustomerName;
                this.Customer_Type = '' + customer.Customer_Type;
                if (this.Customer_Type == 1) {
                    this.Person_Name = spcApply.SPCApply_CustomerName;
                    this.Person_Mobile = spcApply.SPCApply_CustomerMobile;
                }
            }
            await this.getCheckCustomerAndCustomerSub();
        },
        copyOrder() {
            this.applyId = this.$route.query.copySPCApplyDataID;
            this.changeOrder();
        },
        async getSPCApplyByID() {
            const res = await this.$newsApi.order.GetSPCApplyByID({ id: this.applyId });
            return res.data.data;
        },
        async getCustomerByID(customerid) {
            const res = await this.$newsApi.order.getCustomerByID({ customerid });
            return res.data.data;
        },
        // 刷新页面
        resetData() {
            Object.assign(this.$data, this.$options.data());
            this.$router.replace({ path: this.$route.path });
            this.getCheckSPCOrderCreate();
            this.getHistoryCustomerList();
            this.$store.dispatch('fetchLocationData');
        },
        resetDataMy() {
            // let time = Date.now();
            // this.$router.push({ path: '/quotationManagement/temporarilyPricesheetadd', query: { t: time } }); // 跳转之前先刷新自己
            this.$store.dispatch('delView', this.$route);
        },
        getFullImageUrl(path) {
            if (!path) return '';
            if (path.indexOf("detail_no_pic")>0) return path;
            if (/^https?:\/\//.test(path)) return path;
            return this.$openFileUrl + path;
        },
        //   // 获取商品图片
        // async GetProductImg(product_id) {
        //     const res = await this.$newsApi.GetProductImg({product_id});
        //     if (res.data.Resultcode == 0) {
        //         this.productImg = res.data.data;
        //     }
        //     console.log('this.productImg', this.productImg);
        // },
        // 显示图片详情
         showImageDetail(product) {
            this.currentProductId = product.Product_ID
            this.showProductImgDialog = true
        },
        submitMountedMethods() {
            this.OrdersSPCConfirm_Goods_List();
            if (this.applyId && this.orders_copy == 0) {
                // 修改临时报价单
                this.$refs.SubmitSpcOrder.getApplyOrdersDetails({ detailsData: this.SPCApplyInfo });
            }
            if (this.applyId && this.orders_copy == 1) {
                // 复制临时报价单
                this.$refs.SubmitSpcOrder.getApplyOrdersDetails({ detailsData: this.SPCApplyInfo });
            }
        }
    }
};
</script>
<style scoped lang="scss">
/deep/.custom-label {
    // background: #f5f7fa !important;
    max-width: 150px !important;
    min-width: 120px !important;
    line-height: 30px;
    display: inline-block;
    text-align: right !important;
    color: #000000;
    font-weight: bold;
}

/deep/ .el-descriptions-item__content {
    display: flex;
    align-items: center;
    color: #000000;
    font-size: 14px;
}
/deep/.form-title {
    line-height: 40px;
    background-color: #eeeeee;
    padding-left: 15px;
}
/deep/.el-table {
    color: #000000;
}
/deep/.el-table thead {
    color: #000000;
}
/deep/ .el-descriptions__body {
    color: #000000;
}
/deep/.el-descriptions-item__label:not(.is-bordered-label) {
    color: #000000;
    font-weight: bold;
    font-size: 14px;
}
/deep/.el-form-item__label {
    color: #000000;
    font-weight: bold;
}
/deep/.info .info-item .label {
    font-weight: bold;
}
/deep/.el-radio {
    color: #000000;
}

/deep/ .el-step__title {
    font-size: 14px !important;
}

/deep/ .el-step__title.is-process {
    font-size: 14px !important;
}

/deep/ .el-tabs__nav-wrap::after {
    height: 1px !important;
}
.list_content_middle {
    display: block;
}
.nav-title {
    padding: 40px 20px 20px 20px;
}

.steps {
    transform: scale(0.85);
}

.content-view {
    background: #fff;
    padding: 20px;
    margin-bottom: 50px;
    overflow-y: auto;
}

.content-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 0px !important;
}

.customers-info {
    margin-top: 20px;
}

.his-customers-list {
    margin-top: 20px;
}

.his-customers {
    line-height: 30px;
}

.signature-tips {
    border: 1px dashed #90dd90;
    font-style: normal;
    font-size: 12px;
    color: #008000;
    line-height: 20px;
    display: inline-block;
    vertical-align: middle;
    margin-left: 10px;
    background-color: #95ffa0;
    padding: 0 4px;
    border-radius: 0 10px 0 10px;
}

.action-title {
    padding-bottom: 15px;
    border-bottom: 1px solid #e4e7ed;
    margin-bottom: 15px;
}

.content {
    height: calc(100vh - 104px);
    min-height: 400px;
    display: flex;
    flex-direction: column;
}

.content-view {
    flex: 1;
    display: flex;
    flex-direction: column;
}

.tabs-container {
    position: relative;
    flex: 1;
    display: flex;
    flex-direction: column;
}

.sticky-tabs {
    position: sticky;
    top: 0;
    z-index: 10;
    background: #fff;
}

.sticky-form {
    padding: 16px;
    background: #fff;
    border-bottom: 1px solid #e4e7ed;
}

.scroll-content {
    flex: 1;
    overflow-y: auto;
    padding: 20px 0;
}
/deep/.storage_list {
    display: block;
}

/* 瀑布流相关样式 */
.table-container {
    max-height: 600px;
    overflow-y: auto;
}

.loading-more {
    text-align: center;
    padding: 20px;
    color: #666;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
}

.no-more-data {
    text-align: center;
    padding: 20px;
    color: #999;
    font-size: 14px;
}

@keyframes rotating {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

.rotating {
    animation: rotating 1s linear infinite;
}

/* 新批次数据分隔线样式 */
/deep/ .new-batch-row {
    border-top: 3px solid #409eff !important;
}

/deep/ .new-batch-row td {
    border-top: 3px solid #409eff !important;
}
</style>
